// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1BulkHoursImportSchema } from './v1/bulk/hoursImportSchema';
import { v1BulkImportResponseSchema } from './v1/bulk/importResponseSchema';

export const bulkImportEventsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const bulkImportEventsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Events imported successfully (synchronous)
 */
export const bulkImportEvents200Schema = z.lazy(() => v1BulkImportResponseSchema);

export const bulkImportEventsMutationRequestSchema = z.lazy(() => v1BulkHoursImportSchema);

export const bulkImportEventsMutationResponseSchema = z.lazy(() => bulkImportEvents200Schema);
